/// <amd-module name="Search/Shared/Constants" />
export namespace TelemetryConstants {
    export const UrlParameterKeyTrackingData = "tracking_data";
}

export namespace SearchHubRouteConstants {
    export const LaunchPoint = "lp";
    export const SearchText = "text";
    export const EntityType = "type";
    export const Filters = "filters";
    export const SortOptions = "sortOptions";
    export const Result = "result";
    export const Action = "action";
    export const IncludeFacets = "includeFacets";
}

export const ExcludeTTISettingKey = "Search/Telemetry/ExcludeMarkingTTI"; // set it on TFS as /Configuration/Settings/Host/Search/Telemetry/ExcludeMarkingTTI at collection host level.
export const NewBrandingFeatureFlag = "VisualStudio.Services.WebPlatform.UseNewBranding";